var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getAutomation } from '@citrus/runtime';
import { Styled } from './Sortable.styled';
/** DISPLAY NAME: &lt;SortableStatic.HeaderRow&gt; */
var StaticHeaderRow = function (_a) {
    var automationId = _a.automationId, children = _a.children;
    return (React.createElement(Styled.StaticItem, __assign({}, getAutomation(automationId, 'static-header-row')), children));
};
export default StaticHeaderRow;
